import React, { Component } from "react";
import { Row, Col } from "shards-react";
import { Button, FormGroup, FormControl } from "react-bootstrap";
import { Select, Form, Image, Input, DatePicker } from "antd";
import moment from "moment";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import categoryService from "../../../../api/Category/CategoryService";
import offerService from "../../../../api/Offer/OfferService";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
const { Option } = Select;
export default class UpdateOffer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      allAvailableOffers: [],
      allAvailableCategories: [],
      files: [],
      selectedOffer: {
        title: null,
        ar_title: null,
        description: null,
        ar_description: null,
        category_id: null,
        map_url: null,
        rating: null,
        no_users: null,
        offer_type: null,
        link: null,
        mobile: null,
        expireDate: null,
      },
    };

    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {
    this.getAllCategories();
    this.getAllOffers();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }

  componentWillUnmount() {}

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() {}

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };

  //Get All Categories
  getAllCategories = () => {
    this.setState({ allAvailableCategories: [] });
    categoryService
      .getAllCategories()
      .then((res) => {
        res.data.map((cat, i) => {
          console.log("category:", cat);
          return this.setState({
            allAvailableCategories: [
              ...this.state.allAvailableCategories,
              {
                key: i + 1,
                id: cat.id,
                name: cat.name,
              },
            ],
          });
        });
      })
      .catch((err) => {
        toast.error(err.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };

  //Get All Offers
  getAllOffers = () => {
    this.setState({ allAvailableOffers: [] });
    offerService
      .getAllOffers()
      .then((res) => {
        res.data.map((offer, i) => {
          console.log("offer:", offer);
          return this.setState({
            allAvailableOffers: [
              ...this.state.allAvailableOffers,
              {
                key: i + 1,
                id: offer.id,
                title: offer.title,
                ar_title: offer.ar_title,
                description: offer.description,
                ar_description: offer.ar_description,
                summary: offer.summary,
                ar_summary: offer.ar_summary,
                category_id: offer.category_id,
                map_url: offer.map_url,
                rating: offer.rating,
                no_users: offer.no_users,
                offer_type: offer.offer_type,
                link: offer.link,
                mobile: offer.mobile,
              },
            ],
          });
        });
      })
      .catch((err) => {
        toast.error(err.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };

  selectCategories = () => {
    return this.state.allAvailableCategories?.map((cat) => {
      return <option value={cat.id}>{cat.name}</option>;
    });
  };

  selectOffers = () => {
    return this.state.allAvailableOffers?.map((offer) => {
      return <option value={offer.id}>{offer.title}</option>;
    });
  };

  onSelectOffer = (e) => {
    this.state.allAvailableOffers.map((offer) => {
      e.target.value === offer.id &&
        this.setState({
          selectedOffer: {
            id: offer.id,
            title: offer.title,
            ar_title: offer.ar_title,
            description: offer.description,
            ar_description: offer.ar_description,
            summary: offer.summary,
            ar_summary: offer.ar_summary,
            category_id: offer.category_id,
            map_url: offer.map_url,
            link: offer.link,
            mobile: offer.mobile,
            rating: offer.rating,
            no_users: offer.no_users,
            offer_type: offer.offer_type,
          },
        });
    });
  };

  updateOffer = () => {
    const formData = new FormData();
    if (this.state.files)
      for (let i = 0; i < this.state.files.length; i++) {
        formData.append("documents", this.state.files[i]);
      }
    formData.append("title", this.state.selectedOffer.title);
    formData.append("ar_title", this.state.selectedOffer.ar_title);
    this.state.selectedOffer.description &&
      formData.append("description", this.state.selectedOffer.description);
    this.state.selectedOffer.ar_description &&
      formData.append(
        "ar_description",
        this.state.selectedOffer.ar_description
      );
    this.state.selectedOffer.summary &&
      formData.append("summary", this.state.selectedOffer.summary);
    this.state.selectedOffer.ar_summary &&
      formData.append("ar_summary", this.state.selectedOffer.ar_summary);
    if (
      this.state.selectedOffer.map_url ||
      !/^\s+$/.test(this.state.selectedOffer.map_url) ||
      this.state.selectedOffer.map_url != undefined ||
      this.state.selectedOffer.map_url != null
    )
      formData.append("map_url", this.state.selectedOffer.map_url);
    else formData.append("map_url", null);
    if (
      this.state.selectedOffer.link ||
      !/^\s+$/.test(this.state.selectedOffer.link) ||
      this.state.selectedOffer.link != undefined ||
      this.state.selectedOffer.link != null
    )
      formData.append("link", this.state.selectedOffer.link);
    else formData.append("link", null);
    if (
      this.state.selectedOffer.mobile ||
      !/^\s+$/.test(this.state.selectedOffer.mobile) ||
      this.state.selectedOffer.mobile != undefined ||
      this.state.selectedOffer.mobile != null
    )
      formData.append("mobile", this.state.selectedOffer.mobile);
    else formData.append("mobile", null);
    formData.append("category_id", this.state.selectedOffer.category_id);
    formData.append(
      "rating",
      this.state.selectedOffer.rating ? this.state.selectedOffer.rating : 0
    );
    formData.append(
      "no_users",
      this.state.selectedOffer.no_users ? this.state.selectedOffer.no_users : 0
    );
    formData.append("offer_type", this.state.selectedOffer.offer_type);

    console.log("selected offer", this.state.selectedOffer);
    formData.append("status", this.state.selectedOffer.status);
    this.state.selectedOffer.expireDate &&
      formData.append("expireDate", this.state.selectedOffer.expireDate);

    offerService.editOffer(this.state.selectedOffer.id, formData);
    document.getElementById("img").value = "";
    document.getElementById("title").value = "";
    document.getElementById("mobile").value = "";
    document.getElementById("link").value = "";
    document.getElementById("summary").value = "";
    document.getElementById("select").value = "";

    toast.success(`Offer Updated Successfuly`, {
      position: toast.POSITION.TOP_CENTER,
    });
    this.getAllOffers();
  };

  onFileSelect = (e) => {
    this.setState({ files: e.target.files });
  };

  onDateChange = (value) => {
    let date = moment(value).format("YYYY/MM/DD");
    let selectedOffer = this.state.selectedOffer;
    selectedOffer.expireDate = date;
    this.setState({ selectedOffer });
  };

  onChangeOfferData = (e) => {
    let selectedOffer = this.state.selectedOffer;
    selectedOffer[e.target.name] = e.target.value;
    this.setState({ selectedOffer });
  };

  onChangeOfferDescriptionData = (name, value) => {
    let selectedOffer = this.state.selectedOffer;
    selectedOffer[name] = value;
    this.setState({ selectedOffer });
  };

  onChangeOfferMapUrlData = (e) => {
    let selectedOffer = this.state.selectedOffer;
    if (/^\s+$/.test(e.target.value)) selectedOffer.map_url = null;
    else selectedOffer.map_url = e.target.value;
    this.setState({ selectedOffer });
  };

  render() {
    let selectOffers = this.selectOffers();
    let selectCategories = this.selectCategories();
    return (
      <>
        <Row>
          <Col>
            <h5 className="m-0">Update Offer</h5>
          </Col>
          <Col>
            <div class="form-group" id="role">
              <select
                class="form-control"
                id="role"
                name="category_id"
                onChange={this.onSelectOffer}
              >
                <option value="#">Select Offer</option>
                {selectOffers}
              </select>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <Image
              width={200}
              src={
                this.state.selectedOffer.img_path
                  ? this.state.selectedOffer.img_path
                  : "error"
              }
              fallback="data:image/png;base64,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"
            />
          </Col>
        </Row>
        <Row form>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="img" id="create-user">
              <FormControl
                autoFocus
                type="file"
                name="img"
                id="img"
                multiple
                onChange={this.onFileSelect.bind(this)}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Title</label>
              <FormControl
                autoFocus
                type="text"
                name="title"
                id="title"
                onChange={this.onChangeOfferData}
                defaultValue={this.state.selectedOffer.title}
              />
            </FormGroup>
            <FormGroup controlId="email" id="create-user">
              <label>Arabic Title</label>
              <FormControl
                autoFocus
                type="text"
                name="ar_title"
                id="ar_title"
                onChange={this.onChangeOfferData}
                defaultValue={this.state.selectedOffer.ar_title}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group  mt-4">
            <Form layout="vertical">
              <Form.Item label="Select Category">
                <Select
                  id="select"
                  name="category_id"
                  onChange={(value) => {
                    this.onChangeOfferData({
                      target: { name: "category_id", value: value },
                    });
                  }}
                  value={
                    this.state.selectedOffer
                      ? this.state.selectedOffer.category_id
                      : "Select Category"
                  }
                >
                  {this.state.allAvailableCategories.map((cat) => {
                    return <Option value={cat.id}>{cat.name}</Option>;
                  })}
                </Select>
              </Form.Item>
            </Form>
          </Col>
          {/* <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Description</label>
              <FormControl
                autoFocus
                type="text"
                name="description"
                id="description"
                onChange={this.onChangeOfferData}
                defaultValue={this.state.selectedOffer.description}
              />
            </FormGroup>
          </Col> */}
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Expire Date</label>
              <DatePicker
                style={{ width: "100%" }}
                class="form-control-select"
                id="role"
                onChange={this.onDateChange}
                allowClear={false}
                format={"DD-MM-YYYY"}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Description</label>
              <CKEditor
                editor={ClassicEditor}
                data={
                  this.state.selectedOffer.description
                    ? this.state.selectedOffer.description
                    : "Waiting data to Load..."
                }
                onReady={(editor) => {
                  // You can store the "editor" and use when it is needed.
                  console.log("Editor is ready to use!", editor);
                }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  //console.log( { event, editor, data } );
                  this.onChangeOfferDescriptionData("description", data);
                }}
                onBlur={(event, editor) => {
                  console.log("Blur.", editor);
                }}
                onFocus={(event, editor) => {
                  console.log("Focus.", editor);
                }}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Arabic Description</label>
              <CKEditor
                editor={ClassicEditor}
                data={
                  this.state.selectedOffer.ar_description
                    ? this.state.selectedOffer.ar_description
                    : "Waiting data to Load..."
                }
                onReady={(editor) => {
                  // You can store the "editor" and use when it is needed.
                  console.log("Editor is ready to use!", editor);
                }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  //console.log( { event, editor, data } );
                  this.onChangeOfferDescriptionData("ar_description", data);
                }}
                onBlur={(event, editor) => {
                  console.log("Blur.", editor);
                }}
                onFocus={(event, editor) => {
                  console.log("Focus.", editor);
                }}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Summary</label>
              <FormControl
                autoFocus
                type="text"
                name="summary"
                id="summary"
                onChange={this.onChangeOfferData}
                defaultValue={this.state.selectedOffer.summary}
              />
            </FormGroup>
            <FormGroup controlId="email" id="create-user">
              <label>Arabic Summary</label>
              <FormControl
                autoFocus
                type="text"
                name="ar_summary"
                id="ar_summary"
                onChange={this.onChangeOfferData}
                defaultValue={this.state.selectedOffer.ar_summary}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>MAP URL</label>
              <Input
                allowClear
                // <FormControl
                // allowClear
                type="text"
                name="map_url"
                id="map_url"
                onChange={this.onChangeOfferMapUrlData}
                defaultValue={this.state.selectedOffer.map_url}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Mobile</label>
              <Input
                allowClear
                // <FormControl
                // allowClear
                type="text"
                name="mobile"
                id="mobile"
                onChange={this.onChangeOfferData}
                defaultValue={this.state.selectedOffer.mobile}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Link</label>
              <Input
                allowClear
                // <FormControl
                // allowClear
                type="text"
                name="link"
                id="link"
                onChange={this.onChangeOfferData}
                defaultValue={this.state.selectedOffer.link}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group  mt-4">
            <Form layout="vertical">
              <Form.Item label="Offer Type">
                <Select
                  id="select"
                  name="offer_type"
                  onChange={(value) => {
                    this.onChangeOfferData({
                      target: { name: "offer_type", value: value },
                    });
                  }}
                  value={
                    this.state.selectedOffer
                      ? this.state.selectedOffer.offer_type
                      : "Select Type"
                  }
                >
                  <Option value="internal">Internal</Option>
                  <Option value="offers">Offers</Option>
                </Select>
              </Form.Item>
            </Form>
          </Col>
          <Col md="6" className="form-group  mt-4">
            <Form layout="vertical">
              <Form.Item label="Offer Status">
                <Select
                  id="select"
                  name="status"
                  onChange={(value) => {
                    this.onChangeOfferData({
                      target: { name: "status", value: value },
                    });
                  }}
                  value={
                    this.state.selectedOffer
                      ? this.state.selectedOffer.status
                      : "Select Status"
                  }
                >
                  <Option value="draft">Draft</Option>
                  <Option value="published">Published</Option>
                  <Option value="expired">Expired</Option>
                </Select>
              </Form.Item>
            </Form>
          </Col>
        </Row>

        <Row form>
          <Col
            md="6"
            className="form-group pt-2 align-self-center"
            align="right"
          >
            <Button
              className="btn btn-dark text-white w-25"
              onClick={this.updateOffer}
            >
              Update
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}
